<template>
  <transition name="rd-panel">
    <aside
      v-if="top"
      ref="panel"
      class="rd-panel"
      :class="{ 'rd-panel--full': top.wide }"
      role="dialog"
      :aria-label="top.title"
      tabindex="-1"
      @keydown.esc.stop="$emit('close')"
      @keydown.tab="keepFocus"
    >
      <div class="rd-panel__head">
        <button
          v-if="stack.length > 1"
          type="button"
          class="ui-icon-btn ui-icon-btn--sm"
          :aria-label="$t('report_mobile.back')"
          @click="$emit('back')"
        >
          <v-icon size="18">mdi-chevron-left</v-icon>
        </button>
        <h2>
          {{ top.title }}
          <small v-if="top.subtitle">{{ top.subtitle }}</small>
        </h2>
        <button
          type="button"
          class="ui-icon-btn ui-icon-btn--sm"
          :aria-label="$t('close')"
          @click="$emit('close')"
        >
          <v-icon size="18">mdi-close</v-icon>
        </button>
      </div>
      <div class="rd-panel__body">
        <component
          :is="top.component"
          :key="top.key"
          v-bind="top.props"
          @open-panel="(entry) => $emit('open', entry)"
          @open-screen="(...args) => $emit('open-screen', ...args)"
          @toast="(...args) => $emit('toast', ...args)"
        ></component>
      </div>
    </aside>
  </transition>
</template>

<script>
/**
 * Panel sa desne strane preko celog ekrana, kao Vuetify navigation drawer: iza njega je tamna zavesa, a klik
 * na nju ili Esc zatvara panel. Detalj reda (radnici firme, mesečni pregled, ko je naručio).
 * Stavka sa `wide: true` (mesec radnika) otvara panel preko cele širine ekrana.
 * Sadržaj bira stavka na vrhu steka ({ key, title, subtitle, component, props }); fokus ulazi u
 * panel pri otvaranju, a Esc ga zatvara.
 */
export default {
  name: "ReportDetailPanel",
  props: {
    stack: {
      type: Array,
      default: () => [],
    },
    /** Panel je preko sadržaja (sa zavesom): Tab ostaje unutar panela. */
    modal: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    top() {
      return this.stack.length ? this.stack[this.stack.length - 1] : null;
    },
  },
  watch: {
    "top.key"(key, previous) {
      if (key && key !== previous) {
        this.$nextTick(() => this.$refs.panel?.focus());
      }
    },
  },
  methods: {
    keepFocus(event) {
      const panel = this.$refs.panel;
      if (!this.modal || !panel) {
        return;
      }
      const items = [...panel.querySelectorAll("button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])")].filter(
        (item) => !item.disabled && item.offsetParent !== null
      );
      if (!items.length) {
        return;
      }
      const first = items[0];
      const last = items[items.length - 1];
      const active = document.activeElement;
      if (event.shiftKey && (active === first || active === panel)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && active === last) {
        event.preventDefault();
        first.focus();
      }
    },
  },
};
</script>
